import { lazily } from "react-lazily";

import { lazyRouteLoader } from "app/utils/lazyRouteLoader";

import type { PreloadingRouteProps } from "app/utils/lazyRouteLoader";

// Routes.tsx imports this module statically, so it is part of the app shell's
// bundle: the page and its preload module may only be imported dynamically
// here, or the split that lets the loader run ahead of the page's chunk is
// lost.

const { BindingsRoute } = lazily(() => import("./BindingsRoot"));

/** The /admin/bindings index route: see BindingsRoot. */
export const bindingsRoute: PreloadingRouteProps = {
  element: <BindingsRoute />,
  loader: lazyRouteLoader({
    load: () =>
      import("./bindingsPreload").then((module) =>
        module.createBindingsLoader(),
      ),
    warm: () => import("./BindingsRoot"),
  }),
  // The page keeps its own query up to date while it is mounted (see
  // useRoutePreloadedQuery), so the provider and search changes it writes to
  // the URL don't need the loader to run again.
  shouldRevalidate: () => false,
};
